import React, { useState } from 'react';
import moment from 'moment/min/moment-with-locales';
import CompetenceTags from './competenceTags';
import { UncontrolledTooltip } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { CreatedBy } from '../../Helpers/enums';
import Swal from 'sweetalert2';
import { deleteCompetenceFromApplicant } from '../../Services/applicantService';
import { createdByIcon } from '../../Helpers/applicantHelper';

const ApplicantCompetence = ({ competence, onStatusRefresh, actionsEnabled }, key) => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);

  const onDeleteApplicantCompetence = (id) => {
    Swal.fire({
      title: t('competences.DELETE_FROM_APPLICANT'),
      showCancelButton: true,
      cancelButtonText: t('common.CANCEL'),
      confirmButtonText: t('common.DELETE'),
      icon: 'warning',
      reverseButtons: true, // Reverses the order of the buttons
      confirmButtonColor: '#dc3545', // Bootstrap's default red
    }).then((result) => {
      if (result.isConfirmed) {
        deleteCompetenceFromApplicant(id).then((result) => {
          onStatusRefresh();
        });
      }
    });
  };

  return (
    <div
      className="d-flex justify-content-between align-items-center"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="d-flex align-items-center">
        <CompetenceTags competences={[competence]} />
        <UncontrolledTooltip delay={{ show: 50, hide: 50 }} target={`iconEstimatedExp-${competence.id}`}>
          {t('modals.ESTIMATED_EXPERIENCE')}
        </UncontrolledTooltip>
        {createdByIcon(competence.id, competence.createdBy, t)}
        <small className="text-muted d-flex align-items-center">{moment(competence.created).fromNow()}</small>
      </div>

      {isHovered && (competence.createdBy === CreatedBy.Recruiter || competence.createdBy === 2) && actionsEnabled && (
        <i
          id={`btnDeleteComment-${competence.id}`}
          className="fa fa-trash far icon-hover-effect"
          onClick={() => onDeleteApplicantCompetence(competence.id)}
        />
      )}
    </div>
  );
};

export default ApplicantCompetence;
